<template>
  <v-container fluid>
    <v-row>
      <v-col cols="4" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="mr-2 mt-2 float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.drugId')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.drugIdStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.drugNumber ? getdrug.drugNumber : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="mr-2 mt-2 float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.drugName')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.drugNameSatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{ getdrug.drugName ? getdrug.drugName : "Not Specified" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="mr-2 mt-2 float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.drugGenericname')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.drugGenericnameStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.genericName ? getdrug.genericName : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
       <v-col cols="4" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="mr-2 mt-2 float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.drugFormate')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.drugFormateSatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.drugFormate ? getdrug.drugFormate : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="mr-2 mt-2 float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.drugDozecalf')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.drugDozecalfSatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{ getdrug.dozeForCalf ? getdrug.dozeForCalf : "Not Specified" }} {{ getdrug.dozeForCalfUom }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="mr-2 mt-2 float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.drugDozedam')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.drugDozedamStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{ getdrug.dozeForDam ? getdrug.dozeForDam : "Not Specified" }} {{ getdrug.dozeForDamUom }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="mr-2 mt-2 float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.drugManufacturer')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.drugManufacturerStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.manufacturer
                      ? getdrug.manufacturer
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="mr-2 mt-2 float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.drugDistributor')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.drugDistributorStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.distributor ? getdrug.distributor : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="mr-2 mt-2 float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.drugRegistrationdate')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.drugRegistrationdateStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                  getdrug.date?getdrug.date:"XXXXX"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="mr-2 mt-2 float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.drugActiveingridents')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.drugActiveingridentsStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.activeIngredients
                      ? getdrug.activeIngredients
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="mr-2 mt-2 float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.drugSubstitutionId')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.drugSubstitutionIdStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.substituteDrugNo
                      ? getdrug.substituteDrugNo
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="mr-2 mt-2 float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.packId')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packIdStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{ getdrug.packId ? getdrug.packId : "Not Specified" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <!-- <v-icon class="mr-2 mt-2 float-right">mdi-dots-horizontal</v-icon> -->
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>
                  {{$t('drug.packBatchNumber')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packBatchNumberStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.packBatchNumber
                      ? getdrug.packBatchNumber
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Information",
  computed: {
    ...mapGetters(["getdrug"]),
  },
};
</script>